import React from "react";
import ReactGA from "react-ga4";
import {
  Grid,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemButton,
  Fab,
  IconButton,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import NewAdvertiserDialog from "./components/NewAdvertiserDialog";
import EditAdDialog from "./components/EditAdDialog";
import { EventContext } from "../../contexts/EventContext";
import request from "../../utilities/requests";

const Ads = () => {
  const { userData } = React.useContext(EventContext);
  const [advertisers, setAdvertisers] = React.useState([]);
  const [ads, setAds] = React.useState([]);
  const [newAdvertiserOpen, setnewAdvertiserOpen] = React.useState(false);
  const [selectedAdvertiser, setSelectedAdvertiser] = React.useState(null);
  const [editAdvertiser, setEditAdvertiser] = React.useState(null);
  const [newAdOpen, setNewAdOpen] = React.useState(false);
  const [selectedAd, setSelectedAd] = React.useState(null);
  const [editAdOpen, setEditAdOpen] = React.useState(false);

  React.useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/ads",
      title: "Ads",
    });
  }, []);

  React.useEffect(() => {
    getAdvertisers();
  }, []);

  React.useEffect(() => {
    if (selectedAdvertiser) {
      getAds();
    }
  }, [selectedAdvertiser]);

  const getAdvertisers = async () => {
    const result = await request("ads/advertisers");
    if (result.success) {
      setAdvertisers(result.advertisers);
    }
  };

  const getAds = async () => {
    const result = await request(
      `ads/ads?advertiserId=${selectedAdvertiser._id}`
    );
    if (result.success) {
      setAds(result.ads);
    }
  };

  return (
    <Grid container spacing={3} style={{ padding: 20 }}>
      <Grid item xs={12} md={6}>
        <Paper
          elevation={3}
          style={{
            width: "100%",
            height: 300,
            padding: 10,
            position: "relative",
          }}
        >
          <Grid container direction="column">
            <Grid item>
              <Typography variant="h5">Advertisers</Typography>
            </Grid>
            <Grid item>
              <List
                style={{
                  maxHeight: 200,
                  overflowY: "scroll",
                  marginBottom: 10,
                }}
              >
                {advertisers.map((advertiser) => {
                  return (
                    <ListItem
                      key={advertiser._id}
                      secondaryAction={
                        <IconButton
                          edge="end"
                          onClick={() => {
                            setEditAdvertiser(advertiser);
                            setnewAdvertiserOpen(true);
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      }
                    >
                      <ListItemButton
                        onClick={() => setSelectedAdvertiser(advertiser)}
                      >
                        {advertiser.name}
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
            <Grid
              item
              style={{
                display: "flex",
                direction: "row",
                justifyContent: "flex-end",
              }}
            ></Grid>
            <Fab
              size="small"
              color="primary"
              style={{ position: "absolute", bottom: 0, right: 0 }}
              onClick={() => {
                setEditAdvertiser(null);
                setnewAdvertiserOpen(true);
              }}
            >
              <AddIcon />
            </Fab>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12} md={6}>
        <Paper
          elevation={3}
          style={{
            width: "100%",
            height: 300,
            padding: 10,
            position: "relative",
          }}
        >
          <Grid container direction="column">
            <Grid item>
              <Typography variant="h5">
                {selectedAdvertiser?.name} Ads
              </Typography>
            </Grid>
            <Grid item>
              {selectedAdvertiser ? (
                <List
                  style={{
                    maxHeight: 200,
                    overflowY: "scroll",
                    marginBottom: 10,
                  }}
                >
                  {ads.map((ad) => {
                    return (
                      <ListItem key={ad._id}>
                        <ListItemButton
                          onClick={() => {
                            setSelectedAd(ad);
                            setEditAdOpen(true);
                          }}
                        >
                          {ad?.name}
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                </List>
              ) : (
                <Typography>Select an Advertiser</Typography>
              )}
            </Grid>
          </Grid>
          {selectedAdvertiser ? (
            <Fab
              size="small"
              color="primary"
              style={{ position: "absolute", bottom: 0, right: 0 }}
              onClick={() => setEditAdOpen(true)}
            >
              <AddIcon />
            </Fab>
          ) : (
            <></>
          )}
        </Paper>
      </Grid>

      <NewAdvertiserDialog
        open={newAdvertiserOpen}
        close={() => {
          setnewAdvertiserOpen(false);
          getAdvertisers();
        }}
        advertiser={editAdvertiser}
      />
      <EditAdDialog
        open={editAdOpen}
        close={() => {
          setEditAdOpen(false);
          getAds();
          setSelectedAd(null);
        }}
        ad={selectedAd}
        advertiser={selectedAdvertiser}
      />
    </Grid>
  );
};

export default Ads;
